import { Link } from 'react-router-dom'
import logo from './assets/logo.png'
function Navbar() {
  return (
    <div className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt='Experimentum'/>
      </div>
      <div className="navbar-menu">
        <Link to='/'>APOD </Link>
        <Link to='/about'>ABOUT </Link>
      </div>
    </div>
  )
}

export default Navbar
